<template>
  <div>
    <div class="heading-travel-policy">
      <span :class="hotelPreferredVendorObj.isActive ? 'tag is-success' : 'tag'">Standard rule</span>

      <div class="right-content">
        <div class="lefttext">
          <p class="paragrapgh">{{ title }}</p>
          <p>Trigger when the hotel is not a preferred vendor</p>
        </div>
        <div class="allbtns">
          <b-switch :rounded="true" :value="hotelPreferredVendorObj.isActive" v-model="hotelPreferredVendorObj.isActive"
            @input="hotelPreferredVendor" :left-label="true">{{ hotelPreferredVendorObj.isActive ? 'Active' : 'Inactive'
            }}
          </b-switch>
        </div>
      </div>
    </div>
    <StandardRuleActions v-if="hotelPreferredVendorObj.isActive" :ruleObj="hotelPreferredVendorObj" :title="title"
      @save="updateActions" />
  </div>
</template>
<script>
import StandardRuleActions from "../StandardRuleActions.vue";
export default {
  name: "",
  props: {
    value: {
      type: [Object],
    },
  },
  components: {
    StandardRuleActions
  },
  data() {
    return {
      hotelPreferredVendorObj: this.value
        ? this.value
        : {
          name: "hotelPreferredVendor",
          isActive: false,
          type: "hotel",
          message: "Hotel is not a preferred vendor",
        },
      title: "Hotel is not a preferred vendor"
    };
  },
  methods: {
    hotelPreferredVendor() {
      if (!this.hotelPreferredVendorObj.isActive) {
        // Clear the custom action parameters when deactivating
        this.clearActionParams();
      }

      this.emitRuleObj();
    },
    clearActionParams() {
      // Reset to default actions when rule is not active ()
      this.hotelPreferredVendorObj.useCustomActions = false;
      delete this.hotelPreferredVendorObj.visibility;
      delete this.hotelPreferredVendorObj.approvalLevel;
      delete this.hotelPreferredVendorObj.notifications;
    },
    updateActions(updatedRule) {
      // Merge the updated properties into hotelPreferredVendorObj
      this.hotelPreferredVendorObj = { ...this.hotelPreferredVendorObj, ...updatedRule };

      // If useCustomActions is false, delete the associated properties
      if (!updatedRule.useCustomActions) {
        this.clearActionParams()
      }

      this.emitRuleObj();
    },
    emitRuleObj() {
      this.$emit("hotelPreferredVendor", this.hotelPreferredVendorObj);
    },
  },
  mounted() {
    this.hotelPreferredVendorObj.type = "hotel";

    this.emitRuleObj();
  },
  watch: {
    value: {
      handler(newVal, prevVal) {
        this.hotelPreferredVendorObj = this.value;
        this.hotelPreferredVendorObj.type = "hotel";
        this.emitRuleObj();

      },
      deep: true,
    },
  },
};
</script>
